module.exports = __webpack_public_path__ + "img/onDemandSolution.714cd096.svg";